export const SPACING = {
    'space-1': '4px',
    'space-2': '8px',
    'space-3': '12px',
    'space-4': '16px',
    'space-5': '24px',
    'space-6': '32px',
    'space-7': '48px',
    'space-8': '64px',
};
export const BORDERS = {
    'border-largura': '1px',
    'radius-sm': '6px',
    'radius-md': '10px',
    'radius-lg': '16px',
    'radius-full': '9999px',
};
//# sourceMappingURL=spacing.js.map